import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { ToastService } from '../services/toast.service';
import { LoadingService } from '../services/loading.service';
import { ServicioAutenticacion } from '../auth/auth.service';

interface Usuario {
  id: number;
  nombreCompleto: string;
  usuario: string;
  password: string;
  nuevaPassword: string;
  confirmarPassword: string;
  tipoUsuario: any;
  activo: boolean;
  roles: string[];
}

@Component({
  selector: 'app-usuario-editar',
  templateUrl: './usuario-editar.component.html',
  styleUrl: './usuario-editar.component.css',
})
export class UsuarioEditarComponent implements OnInit {
  usuario: Usuario = {
    id: 0,
    nombreCompleto: '',
    usuario: '',
    password: '',
    nuevaPassword: '',
    confirmarPassword: '',
    tipoUsuario: null,
    activo: true,
    roles: [],
  };

  errores: { [key: string]: string } = {};
  cambiarPassword: boolean = false;
  roles: string[] = [];
  rolesUsuario: string[] = [];

  constructor(
    private apiService: ApiService,
    private toastService: ToastService,
    private loadingService: LoadingService,
    private authService: ServicioAutenticacion
  ) {}

  ngOnInit() {
    this.cargarUsuario();
    this.cargarRoles();
  }

  cargarUsuario() {
    this.loadingService.setLoading(true);
    this.apiService.obtenerUsuarioPorNombreUsuario().subscribe({
      next: (data: any) => {
        if (data) {
          this.usuario = {
            id: data.id,
            nombreCompleto: data.nombreCompleto,
            usuario: data.usuario,
            password: '',
            nuevaPassword: '',
            confirmarPassword: '',
            tipoUsuario: data.tipoUsuario,
            activo: data.activo,
            roles: data.roles || [],
          };
          this.rolesUsuario = [...this.usuario.roles];
        } else {
          this.toastService.mostrarNotificacion(
            'No se encontró información del usuario',
            'error'
          );
        }
        this.loadingService.setLoading(false);
      },
      error: (error) => {
        this.toastService.mostrarNotificacion(
          'Error al cargar los datos del usuario',
          'error'
        );
        this.loadingService.setLoading(false);
      },
    });
  }

  cargarRoles() {
    this.apiService.obtenerTodosLosRoles().subscribe({
      next: (roles: string[]) => {
        this.roles = roles;
      },
      error: (error) => {
        this.toastService.mostrarNotificacion(
          'Error al cargar los roles disponibles',
          'error'
        );
      },
    });
  }

  guardarUsuario() {
    this.errores = {};

    if (!this.validarFormulario()) {
      return;
    }

    const usuarioActualizado = this.prepararUsuarioParaEnvio();
    this.loadingService.setLoading(true);

    this.apiService
      .actualizarUsuario(btoa(this.usuario.id.toString()), usuarioActualizado)
      .subscribe({
        next: (respuesta) => {
          this.toastService.mostrarNotificacion(
            'Usuario actualizado correctamente',
            'success'
          );
          this.usuario.password = '';
          this.usuario.nuevaPassword = '';
          this.usuario.confirmarPassword = '';
          if (!this.cambiarPassword) {
            this.loadingService.setLoading(false);
          }
          if (this.cambiarPassword) {
            this.cambiarPassword = false;
            this.toastService.mostrarNotificacion(
              'Se cerrará sesión en 5 segundos',
              'warning'
            );
            setTimeout(() => {
              this.authService.cerrarSesion();
            }, 5000);
          }
        },
        error: (error) => {
          let mensajeError = 'Error al actualizar el usuario';
          if (error.error) {
            mensajeError += `: ${error.error}`;
          }
          this.toastService.mostrarNotificacion(mensajeError, 'error');
          this.loadingService.setLoading(false);
        },
      });
  }

  prepararUsuarioParaEnvio() {
    const rolesActualizados = this.rolesUsuario;

    const usuarioActualizado: any = {
      nombreCompleto: this.usuario.nombreCompleto,
      usuario: this.usuario.usuario,
      tipoUsuario: this.usuario.tipoUsuario?.id || 1,
      activo: this.usuario.activo,
      roles: rolesActualizados,
    };

    if (this.cambiarPassword && this.usuario.nuevaPassword) {
      usuarioActualizado.contrasena = btoa(this.usuario.nuevaPassword);
    }

    return usuarioActualizado;
  }

  validarFormulario(): boolean {
    if (
      !this.usuario.nombreCompleto ||
      this.usuario.nombreCompleto.trim() === ''
    ) {
      this.errores['nombreCompleto'] = 'El nombre completo es obligatorio';
    }

    if (this.cambiarPassword) {
      if (!this.usuario.nuevaPassword) {
        this.errores['nuevaPassword'] = 'La nueva contraseña es obligatoria';
      }

      if (!this.usuario.confirmarPassword) {
        this.errores['confirmarPassword'] =
          'Debe confirmar la nueva contraseña';
      } else if (
        this.usuario.nuevaPassword !== this.usuario.confirmarPassword
      ) {
        this.errores['confirmarPassword'] = 'Las contraseñas no coinciden';
      }
    }

    return Object.keys(this.errores).length === 0;
  }

  toggleCambiarPassword() {
    this.cambiarPassword = !this.cambiarPassword;
    if (!this.cambiarPassword) {
      this.usuario.nuevaPassword = '';
      this.usuario.confirmarPassword = '';
      delete this.errores['nuevaPassword'];
      delete this.errores['confirmarPassword'];
    }
  }
}
